import { render, staticRenderFns } from "./AssessmentReview.vue?vue&type=template&id=8cf48724"
import script from "./AssessmentReview.vue?vue&type=script&lang=js"
export * from "./AssessmentReview.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReview.vue?vue&type=style&index=0&id=8cf48724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports